type ListenerArray = Array<{
  target: Document | Window;
  listener: () => void;
}>;

type AttachedListeners = Record<string, ListenerArray>;

class ListenerHandler {
  private static attachedListeners: AttachedListeners = {};

  public attachListener(target: Document | Window, eventName: string, listener: () => void): void {
    target.addEventListener(eventName, listener);
    if (!ListenerHandler.attachedListeners[eventName]) {
      ListenerHandler.attachedListeners[eventName] = [];
    }
    ListenerHandler.attachedListeners[eventName].push({ listener, target });
  }

  public detachListeners(target: Document | Window): void {
    for (const listenerName in ListenerHandler.attachedListeners) {
      (ListenerHandler.attachedListeners[listenerName] || []).forEach((listenerObject) => {
        if (listenerObject.target === target) {
          target.removeEventListener(listenerName, listenerObject.listener);
          ListenerHandler.attachedListeners[listenerName] = [];
        }
      });
    }
  }
}

export default ListenerHandler;
